import{a as e,b as r}from"./chunk-FN7APMDR.js";import{e as n,m as t}from"./chunk-HBP5N4FR.js";var h,s=n(()=>{t();r();h=o=>e.get(o).then(a=>a.data)});export{h as a,s as b};
//# sourceMappingURL=chunk-N2ITRDLW.js.map
